import { useEffect, useState, useCallback } from 'react';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import DateEditor from '@inovua/reactdatagrid-community/DateEditor';

export default function LineItemsDataGrid(props) {
  const [dataSource, setDataSource] = useState(props.lineItems);
  const onChange = props.onChange;

  useEffect(() => {
    setDataSource(props.lineItems);
  }, [props.lineItems]);

  const gridStyle = { minHeight: 400 };

  const scrollProps = { autoHide: false };

  const defaultSortInfo = { name: 'sku', dir: 1 };

  const columns = [
    { name: 'id', header: 'ID', defaultFlex: 1, defaultVisible: false, editable: false },
    { name: 'sku', defaultFlex: 1, header: 'SKU', editable: false },
    { name: 'item_name', defaultFlex: 3, header: 'Item Name', editable: false },
    { name: 'use_by_date', defaultFlex: 1, header: 'Use by Date', editor: DateEditor },
    { name: 'unit_price', defaultFlex: 1, header: 'Unit Price', type: 'number' },
    { name: 'quantity_ordered', defaultFlex: 1, header: 'Quantity Ordered', type: 'number', editable: false },
    { name: 'quantity_to_credit', defaultFlex: 1, header: 'Quantity to Credit', type: 'number' },
    {
      name: 'amount_to_credit',
      defaultFlex: 1,
      header: 'Amount to Credit',
      render: ({ data }) => '$' + (data.unit_price * data.quantity_to_credit).toFixed(2),
      type: 'number',
      editable: false
    }
  ];

  const onEditComplete = useCallback(({ value, columnId, rowId }) => {
    const data = [...dataSource];
    var row = data.find(row => {
      return row.id === rowId;
    });
    row[columnId] = value;
    setDataSource(data);
    onChange(data);
  }, [dataSource, onChange]);

  return (
    <ReactDataGrid
      idProperty="id"
      style={gridStyle}
      onEditComplete={onEditComplete}
      scrollProps={scrollProps}
      editable={true}
      defaultSortInfo={defaultSortInfo}
      columns={columns}
      dataSource={dataSource}
    />
  );
}
